import React from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle, ArrowRight } from 'lucide-react';
import { FAQS } from '../mock';

const FAQ = () => {
  return (
    <div className="pt-28 pb-24 min-h-screen">
      <div className="max-w-3xl mx-auto px-5">
        <div className="text-center mb-12">
          <HelpCircle className="h-10 w-10 text-[#f0d582] mx-auto mb-4" />
          <h1 className="font-cinzel text-4xl md:text-6xl text-gold-gradient">FAQ</h1>
          <div className="gold-divider mt-4" />
        </div>
        <div className="space-y-4">
          {FAQS.map((f, i) => (
            <div key={i} className="card-glass rounded-xl p-6"><h3 className="font-cinzel text-lg text-[#f0d582] mb-2">{f.q}</h3><p className="font-jost text-sm text-[#f5ecd9]/70 leading-relaxed">{f.a}</p></div>
          ))}
        </div>
        <div className="text-center mt-12">
          <p className="font-cormorant text-xl text-[#f5ecd9]/60">Didn't find your answer?</p>
          <Link to="/contact" className="inline-flex items-center gap-2 mt-4 text-[#f0d582] border-b border-[#d4af37]/50 pb-1 hover:text-[#ff4da6] transition-colors font-jost text-sm tracking-widest uppercase">Contact Us <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
